// extracted by mini-css-extract-plugin
export default {"reset-password":"ResetPassword_reset-password__m09QK","confirmation":"ResetPassword_confirmation__pue4W"};